import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductType } from 'app/modules/dashboard/store/cart/cart.state';
import { ProductsState } from './products.state';
import { SubscriptionPlan } from 'app/models/subscrition-plan.model';

export const selectProductsState =
  createFeatureSelector<ProductsState>('products');

export const selectGiftCardsProducts = createSelector(
  selectProductsState,
  (productsState: ProductsState) =>
    productsState.giftsCardsState.giftsCardsProducts
);

export const selectSubscritionsProducts = createSelector(
  selectProductsState,
  (productsState: ProductsState) =>
    productsState.subscriptionsState.subscriptionsProducts
);

export const selectProductById = (productId: string) =>
  createSelector(selectProductsState, (productsState: ProductsState) => {
    const giftCard = productsState.giftsCardsState.giftsCardsProducts.find(
      (giftCard) => giftCard.id === productId
    );
    if (giftCard) {
      return { product: giftCard, productType: 'gift-card' as ProductType };
    }
    const option = productsState.optionsState.optionsProducts.find(
      (option) => option.id === productId
    );
    if (option) {
      return { product: option, productType: 'option' as ProductType };
    }
    const subscription =
      productsState.subscriptionsState.subscriptionsProducts.find(
        (subscription) => subscription.id === productId
      );
    return {
      product: subscription,
      productType: 'subscription' as ProductType,
    };
  });

export const selectGiftCardProductByName = (name: string) =>
  createSelector(selectProductsState, (productsState: ProductsState) => {
    const giftCard = productsState.giftsCardsState.giftsCardsProducts.find(
      (giftCard) => giftCard.name === name
    );
    return { product: giftCard, productType: 'gift-card' as ProductType };
  });

export const selectSubscriptionProductByName = (name: string) =>
  createSelector(selectProductsState, (productsState: ProductsState) => {
    const subscription =
      productsState.subscriptionsState.subscriptionsProducts.find(
        (subscription) => subscription.name === name
      );
    return {
      product: subscription,
      productType: 'subscription' as ProductType,
    };
  });

export const selectFamilyOption = createSelector(
  selectProductsState,
  (productsState: ProductsState) =>
    productsState.optionsState.optionsProducts.filter(
      (sub: SubscriptionPlan) => sub.name === 'family'
    )[0]
);

export const selectGiftCardProductLoading = createSelector(
  selectProductsState,
  (productsState: ProductsState) => productsState.giftsCardsState.loading
);

export const selectSubscriptionsProductLoading = createSelector(
  selectProductsState,
  (productsState: ProductsState) => productsState.subscriptionsState.loading
);

export const selectOptionsProductLoading = createSelector(
  selectProductsState,
  (productsState: ProductsState) => productsState.optionsState.loading
);
